import React from 'react';
import {useSelector} from 'react-redux';
import {USER_TYPE} from 'containers/ManageUserPage/userType';
import {Header} from 'components';
import {selectApp} from 'store/selectors';
import Organization from './Organization';
import User from './User';
import Wisbits from './Wisbits';
import i18n from 'i18next';

function DashboardPage() {
  const {user: {name = '', role = '', organization = undefined} = {}} =
    useSelector(selectApp);

  return (
    <>
      <Header
        className="pb-8"
        title={`${i18n.t('dashboardPage.welcomeMessage')} ${name}`}
        subtitle={organization?.name}
      />
      {role === USER_TYPE.SUPER_ADMIN.serverAlias && <Organization />}
      {role === USER_TYPE.ADMIN.serverAlias && <User />}
      {role === USER_TYPE.CONTENT_CREATOR.serverAlias && <Wisbits />}
    </>
  );
}

export default DashboardPage;
